import { STANDARD_ARCHIVE } from '../redux/serverEndpoints';
import * as Utility from '../shared/utility';
export class BaseItem {
    constructor() {
        this._exists = false;
        this.isLoading = false;
        this.GUID = null;
        this.ID = null;
        this.DateModified = null;
        this.DateCreated = null;
        this.IsSaved = false;
    }
    doesExist(exists) {
        this._exists = exists;
    }
    exists() {
        return this._exists;
    }
    //abstract archive(onSuccess: () => any): void;
    standardLoad(item, GUID, endpoint, onSuccess, onFailure) {
        item.GUID = GUID;
        item.isLoading = true;
        Utility.httpRequest(endpoint.url, endpoint.data, null)
            .then((resp) => {
            //console.log("Successful item load", resp);                
            Object.assign(item, resp.data.Data);
            item.doesExist(true);
            item.isLoading = false;
            if (onSuccess !== null && typeof onSuccess === "function") {
                onSuccess(item);
            }
        })
            .catch(err => {
            var _a, _b, _c, _d;
            console.error("Item load error:", (_c = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details) !== null && _c !== void 0 ? _c : err);
            Utility.errorLog(err);
            item.isLoading = false;
            if (onFailure !== null && typeof onFailure === "function") {
                onFailure((_d = err === null || err === void 0 ? void 0 : err.response) === null || _d === void 0 ? void 0 : _d.data, err);
            }
        });
    }
    standardArchive(item, onSuccess, onFailure) {
        item.isLoading = true;
        const endpoint = STANDARD_ARCHIVE(item._apiController, item.GUID);
        Utility.httpRequest(endpoint.url, endpoint.data, null)
            .then((resp) => {
            console.log("Successful item archive", resp);
            //Object.assign(item, resp.data);
            item.doesExist(false);
            item.isLoading = false;
            if (onSuccess !== null && typeof onSuccess === "function") {
                onSuccess(item);
            }
        })
            .catch(err => {
            var _a, _b, _c, _d;
            console.error("Item archive error:", (_c = (_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.details) !== null && _c !== void 0 ? _c : err);
            Utility.errorLog(err);
            item.isLoading = false;
            if (onFailure !== null && typeof onFailure === "function") {
                onFailure((_d = err === null || err === void 0 ? void 0 : err.response) === null || _d === void 0 ? void 0 : _d.data, err);
            }
        });
    }
    getSimpleObject() {
        var dict = {};
        for (var prop in this) {
            var val = this[prop];
            if (val != null && prop != null)
                dict[prop] = val;
        }
        return dict;
    }
}
//# sourceMappingURL=BaseItem.js.map